module.exports = __webpack_public_path__ + "static/media/README.f584dd91.md";